import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { BuyVouchersPage } from "../buy-vouchers/buy-vouchers";

@IonicPage()
@Component({
  selector: "page-vouchers",
  templateUrl: "vouchers.html",
})
export class VouchersPage {
  vouchers: any = VouchersPage;

  constructor(private _navCtrl: NavController) {}

  handleBuyVoucherClick() {
    this._navCtrl.push(BuyVouchersPage);
  }

  handleBack() {
    this._navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/vouchers.ts